import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'equalMessageType',
    standalone: false,
})
export class EqualMessageTypePipe implements PipeTransform {
    transform(toasterType: string, comparableType: string): boolean {
        return toasterType === comparableType;
    }
}
